import actionTypes from '../../action-types'

export default (payload, meta, included) => ({
  type: actionTypes.USER_ROLES.SET_ALL,
  payload,
  meta,
  included,
})
